import { Injectable } from '@angular/core';
import PrivateApiClient from '@bdeo-platform/private-api';
import {
  FetchApi as SmartphotoFetchApi,
  OpenApiSpecification as SmartphotoSpecification
} from '@bdeo-platform/motor-smartphotos-private-api';
import { FetchApi as DamagesFetchApi, OpenApiSpecification as DamagesSpecification } from '@bdeo-platform/motor-damages-private-api';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiClientService {
  private apiClient!: PrivateApiClient;
  private motorSmartphotosAPIClient!: SmartphotoFetchApi.Api<typeof SmartphotoSpecification>;
  private motorDamagesApiClient!: DamagesFetchApi.Api<typeof DamagesSpecification>;
  private baseUrl = '';

  constructor() {
    const { baseUrl } = environment;
    this.baseUrl = baseUrl;
    this.apiClient = new PrivateApiClient(baseUrl);
    this.motorDamagesApiClient = new DamagesFetchApi.Api({ baseUrl: `${baseUrl}/motor/damages` });
    this.motorSmartphotosAPIClient = new SmartphotoFetchApi.Api({ baseUrl: `${baseUrl}/motor/smartphotos` });
  }

  public getApiClient(): PrivateApiClient {
    return this.apiClient;
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }

  public getMotorSmartphotosApiClient(): SmartphotoFetchApi.Api<typeof SmartphotoSpecification> {
    return this.motorSmartphotosAPIClient;
  }

  public getMotorDamagesApiClient(): DamagesFetchApi.Api<typeof DamagesSpecification> {
    return this.motorDamagesApiClient;
  }

  public configure(baseUrl: string, accessToken: string): void {
    this.baseUrl = baseUrl;
    this.apiClient = new PrivateApiClient(baseUrl);
    this.motorDamagesApiClient = new DamagesFetchApi.Api({ baseUrl: `${baseUrl}/motor/damages` });
    this.motorSmartphotosAPIClient = new SmartphotoFetchApi.Api({ baseUrl: `${baseUrl}/motor/smartphotos` });
    this.apiClient.setAccessToken(accessToken);
  }
}
